import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, Home } from 'lucide-react';

export default function AdminLayout({ children }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_email');
    navigate('/admin/login');
  };

  const adminEmail = localStorage.getItem('admin_email');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <Link to="/admin/events" className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded bg-gradient-to-br from-orange-500 to-orange-700 flex items-center justify-center">
                  <Home className="w-5 h-5 text-white" />
                </div>
                <span className="font-bold text-gray-900 text-lg">Admin CMS</span>
              </Link>
              
              <nav className="hidden md:flex space-x-4">
                <Link
                  to="/admin/events"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Events
                </Link>
                <Link
                  to="/admin/events/change-requests"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Change Requests
                </Link>
                <Link
                  to="/admin/submissions"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Submissions
                </Link>
                <Link
                  to="/admin/blogs"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Blog
                </Link>
                <Link
                  to="/admin/reports"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Reports
                </Link>
                <Link
                  to="/admin/embeds"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Embeds
                </Link>
                <Link
                  to="/admin/analytics"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Analytics
                </Link>
                <Link
                  to="/admin/settings"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  Settings
                </Link>
                <Link
                  to="/admin/partner-keys"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors"
                >
                  API Keys
                </Link>
                <Link
                  to="/admin/trending"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors flex items-center gap-1"
                >
                  <span>Trending</span>
                </Link>
                <Link
                  to="/admin/date-verification"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors flex items-center gap-1"
                >
                  <span>Date Check</span>
                </Link>
                <Link
                  to="/admin/url-governance"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors flex items-center gap-1"
                  data-testid="admin-nav-url-governance"
                >
                  <span>Website Review</span>
                </Link>
                <Link
                  to="/admin/translations"
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-orange-600 hover:bg-gray-100 rounded-md transition-colors flex items-center gap-1"
                >
                  <span>Translations</span>
                </Link>
              </nav>
            </div>

            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">{adminEmail}</span>
              <Button
                onClick={handleLogout}
                variant="outline"
                className="flex items-center space-x-2"
                data-testid="admin-logout-button"
              >
                <LogOut className="w-4 h-4" />
                <span>Logout</span>
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}